import validateUrlApi from "@faire/web-api--source/api/brand-lead/validate-url/post";
import validate from "validate.js";
export var SIGNUP_FORM_STAGE;
(function(SIGNUP_FORM_STAGE) {
    SIGNUP_FORM_STAGE[SIGNUP_FORM_STAGE["SIGNUP"] = 0] = "SIGNUP";
    SIGNUP_FORM_STAGE[SIGNUP_FORM_STAGE["CREATE_ACCOUNT"] = 1] = "CREATE_ACCOUNT";
})(SIGNUP_FORM_STAGE || (SIGNUP_FORM_STAGE = {}));
export var BRAND_SIGN_UP_VALIDATION_RULES = function(strictLocalize) {
    return {
        email: {
            presence: {
                allowEmpty: false
            },
            email: true
        },
        companyName: {
            presence: {
                allowEmpty: false,
                message: "^" + strictLocalize({
                    id: "CR5ezS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Brand name can't be blank"
                        }
                    ]
                })
            }
        },
        numProducts: {
            presence: {
                allowEmpty: false,
                message: "^" + strictLocalize({
                    id: "VNs1y6",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please specify the number of wholesale products you sell"
                        }
                    ]
                })
            }
        },
        stockists: {
            presence: {
                allowEmpty: false,
                message: "^" + strictLocalize({
                    id: "p7I10n",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please specify the number of independent stores you work with"
                        }
                    ]
                })
            }
        },
        "country.isoCode": {
            presence: {
                allowEmpty: false,
                message: "^" + strictLocalize({
                    id: "Wya01V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please select a valid country"
                        }
                    ]
                })
            }
        },
        categoryOption: {
            presence: {
                allowEmpty: false,
                message: "^" + strictLocalize({
                    id: "yjQydP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Category can't be blank"
                        }
                    ]
                })
            }
        }
    };
};
export var validateUrlWithErrors = function(value, strictLocalize) {
    return new Promise(function(resolve) {
        if (validate.isEmpty(value)) {
            return resolve(strictLocalize({
                id: "15VwlY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Website URL is required"
                    }
                ]
            }));
        }
        return validateUrlApi(value).then(function(response) {
            if (response) {
                resolve("");
            } else {
                resolve(strictLocalize({
                    id: "dHaihv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please enter a functional website URL"
                        }
                    ]
                }));
            }
        }).catch(function() {
            return resolve(strictLocalize({
                id: "dHaihv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Please enter a functional website URL"
                    }
                ]
            }));
        });
    });
};
export var MAKER_SIGN_UP_BASED_IN_STORAGE_KEY = "makerSignUpBasedIn";
